import React from 'react'

const Coach = ({ children }: { children: React.ReactNode | string }) => {
  return (
    <div className="relative min-w-[250px] max-w-[250px] rounded-[3px] bg-blue2 p-4 shadow-[0_2px_3px_rgba(0,0,0,0.3)]">
      <div className="coach-arrow"></div>
      <div>{children}</div>
    </div>
  )
}

export default Coach
